import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Table, TableBody, TableCell, TablePagination, TableRow } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import EnhancedTableHead from "../../../shared/components/EnhancedTableHead";
import ColorfulChip from "../../../shared/components/ColorfulChip";
import unixToDateString from "../../../shared/functions/unixToDateString";
import HighlightedInformation from "../../../shared/components/HighlightedInformation";
import currencyPrettyPrint from "../../../shared/functions/currencyPrettyPrint";
import { Auth } from 'aws-amplify';
const styles = theme => ({
  tableWrapper: {
    overflowX: "auto",
    width: "100%"
  },
  blackBackground: {
    backgroundColor: theme.palette.primary.main
  },
  contentWrapper: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2)
    },
    width: "100%"
  },
  dBlock: {
    display: "block !important"
  },
  dNone: {
    display: "none !important"
  },
  firstData: {
    paddingLeft: theme.spacing(3)
  }
});

const rows = [
  {
    id: "description",
    numeric: false,
    label: "Action"
  },
  {
    id: "balanceChange",
    numeric: false,
    label: "Balance change"
  },
  {
    id: "date",
    numeric: false,
    label: "Date"
  },
  {
    id: "paidUntil",
    numeric: false,
    label: "Paid until"
  }
];
function getUsage(){

  return Auth.currentSession().then(res=>{
    let idToken = res.getIdToken();
    var jwt = idToken.getJwtToken();
    // console.log(jwt);
    return jwt
    //You can print them to see the full objects
    // console.log(`myAccessToken: ${JSON.stringify(jwt)}`);

  }).catch(err => {
    console.log("error",err)
    return null
  }).then(jwt => {if (jwt !== "undefined"){
    // console.log(`myAccessToken: ${JSON.stringify(jwt)}`);
    if (jwt !== null){
      const headers = {"Authorization": "Bearer "+jwt}
      return fetch('https://lac01h3qq7.execute-api.us-east-1.amazonaws.com/staging/users/plan-usage', {headers:headers})
          .then(response => {
          return response.json()
        }).catch(err=>{
            console.log("error",err)
            return null
      });
    } else{
      return null
    }

  }});
}
const rowsPerPage = 25;

function SubscriptionTable(props) {
  const { transactions, theme, classes, usage, setUsage } = props;
  const [page, setPage] = useState(0);
  // const usage = useRef(null);
  const handleChangePage = useCallback(
    (_, page) => {
      setPage(page);
    },
    [setPage]
  );

  if(usage === null){
    getUsage().then(api_data => {if (api_data !== null) {setUsage(api_data.response.resultMessage.credits_remaining)}})
  }
  console.log("usage", usage);
  return (
    <div className={classes.contentWrapper}>
      <HighlightedInformation>
        No transactions received yet.
      </HighlightedInformation>
    </div>
  );
}

SubscriptionTable.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  transactions: PropTypes.arrayOf(PropTypes.object).isRequired
};
export default withStyles(styles, { withTheme: true })(SubscriptionTable);
